import { PostT, PostTagT } from 'types/shared/core/Post';
import { alpha, Chip, Stack, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';

type PostTagWrapperPropsT = {
  postTags: PostTagT[];
};

const PostTagWrapper = ({ postTags }: PostTagWrapperPropsT) => {
  const { palette } = useTheme();
  const errorColor = alpha(palette.error.light, 0.3);

  return (
    <Stack
      direction="row"
      gap="6px"
      width="100%"
      sx={{
        'alignItems': 'center',
        'overflowX': 'scroll',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}
    >
      {postTags.map((tag, i) => (
        <Chip
          sx={{
            '&.MuiChip-filledDefault': {
              backgroundColor: tag.isDestructive ? errorColor : undefined,
            },
          }}
          key={i}
          label={`# ${tag.tagName}`}
        />
      ))}
    </Stack>
  );
};

// 게시글의 경우 게시판
// 숨겨진 글의 경우 숨겨진 글 이라는 태그를 추가해 태그를 나열해준다.
const ExtendedPostTagWrapper = observer(({ post }: { post: PostT }) => {
  const postTags: PostTagT[] = [];

  // 검토중이라면 검토상태
  if (!post.publishedAt) {
    if (post.reviewStatus === 'rejected') {
      postTags.push({
        tagType: 'general',
        tagValue: '',
        tagName: '반려됨',
        checked: true,
        isDestructive: true,
      });
    } else {
      postTags.push({
        tagType: 'general',
        tagValue: '',
        tagName: '검토중',
        checked: true,
      });
    }
  }

  if (!post.isVisible) {
    postTags.push({
      tagType: 'general',
      tagValue: '',
      tagName: '숨겨진 글',
      checked: true,
    });
  }

  if (!post.isStudentReadable) {
    postTags.push({
      tagType: 'general',
      tagValue: '',
      tagName: '학생 못 봄',
      checked: true,
    });
  }

  if (post.boardList?.length) {
    post.boardList.forEach((board) => {
      postTags.push({
        tagType: 'general',
        tagValue: '',
        tagName: board.name,
        checked: true,
      });
    });
  }
  if (post.postTags?.length) {
    postTags.push(...post.postTags);
  }

  if (postTags.length) {
    return <PostTagWrapper postTags={postTags} />;
  } else {
    return null;
  }
});
export { ExtendedPostTagWrapper };
export default PostTagWrapper;
